"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commentDateTimeOptions = void 0;
exports.commentDateTimeOptions = { hour12: true, dateStyle: 'long', timeStyle: 'short' };
